export default __webpack_public_path__ + "static/media/icon-step-two.fddbcc52.png";